export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9329.25c34933.jpg";